import { CatLoadingIndicator } from 'components/blocks-components';
import styles from './loader-overlay.module.scss';
import cx from 'classnames';

const LoaderOverlay = ({ classNames = '' }: { classNames?: string }) => {
  return (
    <div
      data-testid="loader-overlay"
      className={cx(
        'd-flex justify-content-center position-absolute w-100 h-100 top-0 bottom-0',
        styles['loader-overlay'],
        classNames
      )}
    >
      <CatLoadingIndicator className="position-fixed h-100 top-50" />
    </div>
  );
};

export default LoaderOverlay;
